'use strict';

exports.__esModule = true;
var vendors = ['ms', 'moz', 'webkit', 'o'];
var lastTime = 0;
var _requestAnimationFrame = window.requestAnimationFrame;
var _cancelAnimationFrame = window.cancelAnimationFrame;

for (var x = 0; x < vendors.length && !_requestAnimationFrame; x++) {
  exports.requestAnimationFrame = _requestAnimationFrame = window[vendors[x] + 'RequestAnimationFrame'];
  exports.cancelAnimationFrame = _cancelAnimationFrame = window[vendors[x] + 'CancelAnimationFrame'] || window[vendors[x] + 'CancelRequestAnimationFrame'];
}

if (!_requestAnimationFrame) {
  exports.requestAnimationFrame = _requestAnimationFrame = function (callback) {
    var currTime = new Date().getTime();
    var timeToCall = Math.max(0, 16 - (currTime - lastTime));
    var id = window.setTimeout(function () {
      callback(currTime + timeToCall);
    }, timeToCall);
    lastTime = currTime + timeToCall;
    return id;
  };
}

if (!_cancelAnimationFrame) {
  exports.cancelAnimationFrame = _cancelAnimationFrame = function (id) {
    return clearTimeout(id);
  };
}

// Somehow "export requestAnimationFrame" didn't work with babel?
exports.requestAnimationFrame = _requestAnimationFrame;
exports.cancelAnimationFrame = _cancelAnimationFrame;


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-container-query/lib/raf.js
 ** module id = 116
 ** module chunks = 0
 **/